if ( typeof CountdownClock !== 'function' ) {

  class CountdownClock extends HTMLElement {

    constructor(){
      super();
      this.init();
    }

    init(){

      this.daysEl = this.querySelector('.days');
      this.hoursEl = this.querySelector('.hours');
      this.minutesEl = this.querySelector('.minutes');
      this.secondsEl = this.querySelector('.seconds');

      const date = this.dataset.date.split(',');
      this.COUNT = new Date(date[0], (date[1]-1), date[2], date[3]).getTime();

      const gmt = parseInt(this.dataset.timezone);
      const timezone = new Date().getTimezoneOffset() / -60;

      if ( timezone != gmt ) {
        this.COUNT += (timezone - gmt) * 60 * 60 * 1000;
      } 

      this._countEachSecond();
      
      if ( this.classList.contains('hide') ) {
        this.classList.remove('hide');
      }
    }

    _countEachSecond(){
      const now = new Date().getTime(),
        distance = this.COUNT - now;

      if (distance <= 0) {
        this.parentElement?.classList.add('hide');
        this.style.display = 'none';
        if (this._countdownBannerInterval) {
          clearTimeout(this._countdownBannerInterval);
        }
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const totalHours = Math.floor(distance / (1000 * 60 * 60));

      const showDays = days > 0,
      showHours = totalHours > 0,
      showMinutes = minutes > 0 && (totalHours < 0 || days == 0),
      showSeconds = minutes > 0 && totalHours < 1;

      const formatTimeValue = (value) => {
        return value < 10 ? 
          `<span>0</span><span>${value}</span>` : 
          value.toString().split('').map(digit => `<span>${digit}</span>`).join("");
      };

      const updateElement = (element, value, show) => {
        if (!element) return;
        
        const timeHolder = element.closest('.time-holder');
        const unit = timeHolder?.querySelector('[data-unit]');
        const unitText = unit?.dataset.unit;
        const pluralize = (count, noun, suffix = 's') =>
          `${noun}${count !== 1 ? suffix : ''}`;
        
        if (show) {
          if (timeHolder) {
            timeHolder.classList.remove('hide');
            timeHolder.classList.add('active');
          }
          if (unit) {
            unit.textContent = pluralize(value, unitText);
          }
          element.innerHTML = formatTimeValue(value);
        } else {
          if (timeHolder) {
            timeHolder.classList.remove('active');
            timeHolder.classList.add('hide');
          }
        }
      };

      updateElement(this.daysEl, days, showDays);
      updateElement(this.hoursEl, hours, showHours);
      updateElement(this.minutesEl, minutes, showMinutes);
      updateElement(this.secondsEl, seconds, showSeconds);

      this._updateColonVisibility();

      let interval;
      if (showMinutes && showSeconds) {
        interval = 1000;
      } else if (showHours) {
        interval = 60000;
      } else {
        interval = 3600000;
      }
      
      this._countdownBannerInterval = setTimeout(() => {
        this._countEachSecond();
      }, interval);
    }

    _updateColonVisibility() {
      const activeTimeHolders = this.querySelectorAll('.time-holder.active');
      
      this.querySelectorAll('.colon').forEach(colon => {
        colon.classList.add('hide');
      });
      
      for (let i = 0; i < activeTimeHolders.length - 1; i++) {
        const colon = activeTimeHolders[i].querySelector('.colon');
        if (colon) {
          colon.classList.remove('hide');
        }
      }
    }

    disconnectedCallback() {
      if (this._countdownBannerInterval) {
        clearTimeout(this._countdownBannerInterval);
      }
    }

  }

  if ( typeof customElements.get('countdown-clock') == 'undefined' ) {
    customElements.define('countdown-clock', CountdownClock);
  }

}